import {EntityField} from "../../../core/genericdocuments/EntityField";
import {EntityFieldDataType} from "../../../core/genericdocuments/EntityFieldDataType";
import {EntityFieldsDescriptor} from "../../../core/genericdocuments/EntityFieldsDescriptor";
import {RacunDocument} from "./RacunDocument";
import {baseDocumentFields} from "../BaseDocumentFields";
import {LookupEntities} from "../../../core/genericdocuments/ReferenceDetails";
import {AvansniRacunDocument} from "./AvansniRacunDocument";

// obavezno: datum zavodjenja, delovodni broj, datum dokumenta, broj dokumenta, partner, sektor, iznos
// opciono" opis, lista priloga, tekući račun, datum valute

export const avansniRacunDocumentFields: IntercateKeysMap<AvansniRacunDocument, EntityField<AvansniRacunDocument>> = {
	...baseDocumentFields,
	clientId: {
		name: "clientId", dataType: EntityFieldDataType._reference, label: "Partner",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Customers
		},
		validator: { required: true },
		sortable: true,
		autocomplete: true
	},
	proformaInvoiceNumber: {
		name: "proformaInvoiceNumber", dataType: EntityFieldDataType._string, label: "Broj predračun",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
	payDate: {
		name: "payDate", dataType: EntityFieldDataType._date, label: "Datum uplate",
		validator: { required: false },
		sortable: true,
		filterable: true
	},
	amount: {
		name: "amount", dataType: EntityFieldDataType._number, label: "Iznos",
		validator: { required: true },
		sortable: true
	},
	parentId: {
		name: "parentId", dataType: EntityFieldDataType._derived, label: "Parent",
		value: item => item.clientId,
		hide: formState => true
	}
}

const documentFieldsArray: Array<EntityField<AvansniRacunDocument>> = [
	avansniRacunDocumentFields.indexingNumber,
	avansniRacunDocumentFields.indexingDate,
	avansniRacunDocumentFields.documentNumber,
	avansniRacunDocumentFields.documentDate,
	avansniRacunDocumentFields.assignedTo,
	avansniRacunDocumentFields.clientId,
	avansniRacunDocumentFields.sectorId,
	avansniRacunDocumentFields.payDate,
	avansniRacunDocumentFields.proformaInvoiceNumber,
	avansniRacunDocumentFields.amount,
	avansniRacunDocumentFields.tags,
	avansniRacunDocumentFields.description,
	avansniRacunDocumentFields.parentId
]

export const avansniRacunDocumentFieldsDescriptor: EntityFieldsDescriptor<AvansniRacunDocument> = {
	listFields: documentFieldsArray,
	createFormFields: documentFieldsArray,
	updateFormFields: documentFieldsArray
}
